"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckoutStatus = void 0;
var CheckoutStatus;
(function (CheckoutStatus) {
    CheckoutStatus["UNKNOWN"] = "UNKNOWN";
    CheckoutStatus["ERROR"] = "ERROR";
    CheckoutStatus["INITIALIZING"] = "INITIALIZING";
    CheckoutStatus["INITIALIZED"] = "INITIALIZED";
    CheckoutStatus["CHECKING_OUT"] = "CHECKING_OUT";
    CheckoutStatus["DONE"] = "DONE";
})(CheckoutStatus || (exports.CheckoutStatus = CheckoutStatus = {}));
//# sourceMappingURL=CheckoutTypes.js.map